export default __webpack_public_path__ + "static/media/refercode.647283e0.png";